<div class="dot" *ngIf="open" [class.dark]="isDark">
  <div class="dot-header">
    <span class="dot-title">Árbol de objetos</span>
    <button class="dot-close" (click)="close()"><i class="bi bi-x-lg"></i></button>
  </div>

  <div class="dot-empty" *ngIf="drawings.length === 0">Sin dibujos en el gráfico.</div>

  <div class="dot-list">
    <div class="dot-row" *ngFor="let d of drawings"
         [class.dot-row-selected]="d.id === selectedId"
         (click)="select(d)">
      <i class="dot-row-icon" [ngClass]="icon(d)"></i>
      <span class="dot-row-label">{{ label(d) }}</span>
      <button class="dot-icon-btn" (click)="toggleVisible(d, $event)"
        [title]="isVisible(d) ? 'Ocultar' : 'Mostrar'">
        <i class="bi" [class.bi-eye]="isVisible(d)" [class.bi-eye-slash]="!isVisible(d)"></i>
      </button>
      <button class="dot-icon-btn" (click)="toggleLock(d, $event)"
        [title]="isLocked(d) ? 'Desbloquear' : 'Bloquear'">
        <i class="bi" [class.bi-lock-fill]="isLocked(d)" [class.bi-unlock]="!isLocked(d)"></i>
      </button>
      <button class="dot-icon-btn dot-danger" (click)="remove(d, $event)" title="Eliminar">
        <i class="bi bi-trash3"></i>
      </button>
    </div>
  </div>
</div>
